'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { RequestStatusPropType } from 'developer-docs-shared-components/lib/models/RequestStatus';
import { EVENTS } from '../../../tracking/events';
import { getUsageTracker } from 'developer-docs-shared-components/tracking/usageTracker';
import { fetchSpecification } from 'developer-docs-shared-components/modules/Doc/actions';
import { preventAccessTokenCopyListener } from 'developer-docs-shared-components/utils/accessTokens';
import { getOasDocs, getSpecificationStatus, getSpecificationWithExtensions } from 'developer-docs-shared-components/modules/Doc/selectors/DocSelectors';
import { parse as parseQuery } from 'hub-http/helpers/params';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import LoadingHOC from 'developer-docs-shared-components/lib/hoc/LoadingHOC';
import DeveloperDoc from 'developer-docs-shared-components/modules/Doc/components/DeveloperDoc';

class ApiDeveloperDoc extends Component {
  constructor(props) {
    super(props);
    this.specPath = parseQuery(props.location.search.slice(1)).spec;
    this.tracker = getUsageTracker();
  }

  componentDidMount() {
    this.tracker.track(EVENTS.PAGEVIEW, {
      screen: 'api documentation',
      subscreen: this.specPath
    });

    if (window.newrelic) {
      // New Relic strips out query parameters, so to segment pages we need to use custom attributes
      window.newrelic.setCustomAttribute('specification', this.specPath);
    }

    this.props.fetchSpecification(this.specPath);
    document.addEventListener('copy', preventAccessTokenCopyListener);
  }

  componentWillUnmount() {
    document.removeEventListener('copy', preventAccessTokenCopyListener);
  }

  renderError() {
    const {
      loadingStatus
    } = this.props;
    const details = loadingStatus.get('errorDetails');

    if (details && details.status === 404) {
      return /*#__PURE__*/_jsx(UIErrorMessage, {
        type: "notFound",
        children: /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "error.notFound.body"
          })
        })
      });
    }

    return /*#__PURE__*/_jsx(UIErrorMessage, {
      type: "badRequest"
    });
  }

  render() {
    const {
      loadingStatus,
      oasDocs,
      specWithExtensions
    } = this.props;
    return /*#__PURE__*/_jsx(LoadingHOC, {
      statuses: [loadingStatus],
      error: /*#__PURE__*/_jsx(NavMarker, {
        name: "API_PAGE_ERROR",
        children: this.renderError()
      }),
      children: loadingStatus.succeeded && /*#__PURE__*/_jsx(NavMarker, {
        name: "API_PAGE_LOAD",
        children: /*#__PURE__*/_jsx(DeveloperDoc, {
          oasDocs: oasDocs,
          specWithExtensions: specWithExtensions
        })
      })
    });
  }

}

ApiDeveloperDoc.propTypes = {
  fetchSpecification: PropTypes.func.isRequired,
  loadingStatus: RequestStatusPropType.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }).isRequired,
  oasDocs: PropTypes.array,
  specWithExtensions: PropTypes.object
};

const mapStateToProps = state => {
  return {
    loadingStatus: getSpecificationStatus(state),
    oasDocs: getOasDocs(state),
    specWithExtensions: getSpecificationWithExtensions(state)
  };
};

const mapDispatchToProps = {
  fetchSpecification
};
export default connect(mapStateToProps, mapDispatchToProps)(ApiDeveloperDoc);